import { Text } from '@webstore-monorepo/ui/text';
import type { FC, PropsWithChildren } from 'react';
import React from 'react';

export const BlockTitle: FC<PropsWithChildren> = ({ children }) => (
  <Text fontWeight="500" textTransform="uppercase" fontSize="xs" marginBottom={4}>
    {children}
  </Text>
);
